module.exports = __webpack_public_path__ + "static/pic-4-263f9bc79762fcde888a5e34166551a1.png";